const path = require('path');

// TODO: get from env.js
const isProd = process.env.NODE_ENV === 'production';

// TODO: This is not ideal and we should find a better way to get the root directory of the application
const PROJECT_ROOT = process.cwd();

const BUILD_PATH = path.join(PROJECT_ROOT, 'build');

const SRC_PATH = path.join(PROJECT_ROOT, 'src');

const TESTS_PATH = path.join(PROJECT_ROOT, 'test');

const CLIENT_BUILD_PATH = path.join(BUILD_PATH, 'client');

const SERVER_BUILD_PATH = path.join(BUILD_PATH, 'server');

const FIXTURES_PATH = isProd ? path.join(BUILD_PATH, 'fixtures') : path.join(PROJECT_ROOT, 'test/fixtures');

const VIEWS_PATH = path.join(isProd ? BUILD_PATH : SRC_PATH, 'server/views');

const PAGES_VIEWS_PATH = path.join(VIEWS_PATH, 'pages');

const PUBLIC_URL = 'vanilla-assets';

const ASSETS_PATH = path.join(SRC_PATH, 'client');

const TRANSLATIONS_PATH = path.join(SRC_PATH, 'translations');

const JAVASCRIPT_ASSETS_PATH = path.join(ASSETS_PATH, 'javascript');
const STYLESHEET_ASSETS_PATH = path.join(ASSETS_PATH, 'stylesheets');
const FONTS_PATH = path.join(ASSETS_PATH, 'fonts');
const IMAGE_ASSETS_PATH = path.join(ASSETS_PATH, 'images');

const JAVASCRIPT_CLIENT_BUILD_PATH = path.join(CLIENT_BUILD_PATH, 'javascript');
const STYLESHEET_CLIENT_BUILD_PATH = path.join(CLIENT_BUILD_PATH, 'stylesheets');

const JAVASCRIPT_PUBLIC_URL = path.join(PUBLIC_URL, 'javascript');

const DICTIONARY_PATH = path.join(BUILD_PATH, 'dictionary.json');

const MESSAGES_PATH = path.join(CLIENT_BUILD_PATH, 'messages');

module.exports = {
  PUBLIC_URL,
  SERVER_BUILD_PATH,
  SRC_PATH,
  TESTS_PATH,
  DICTIONARY_PATH,
  MESSAGES_PATH,
  CLIENT_BUILD_PATH,
  JAVASCRIPT_ASSETS_PATH,
  STYLESHEET_ASSETS_PATH,
  IMAGE_ASSETS_PATH,
  JAVASCRIPT_CLIENT_BUILD_PATH,
  STYLESHEET_CLIENT_BUILD_PATH,
  JAVASCRIPT_PUBLIC_URL,
  VIEWS_PATH,
  PAGES_VIEWS_PATH,
  BUILD_PATH,
  FIXTURES_PATH,
  TRANSLATIONS_PATH,
  FONTS_PATH
};
